const CheckerSkeletonLoader = () => {
  return (
    <div className="cy:max-w-7xl cy:mx-auto">
      {/* Main Card */}
      <div className="cy:bg-white cy:rounded-lg cy:shadow-sm cy:border cy:border-gray-200">
        {/* Header */}
        <div className="cy:border-b cy:border-gray-200 cy:pb-6 cy:p-6">
          <div className="cy:flex cy:items-center cy:gap-4 cy:mb-2">
            <div className="cy:h-6 cy:bg-gray-200 cy:rounded cy:w-24 cy:animate-pulse"></div>
            <div className="cy:h-6 cy:w-11 cy:bg-gray-200 cy:rounded-full cy:animate-pulse"></div>
          </div>
          <div className="cy:h-4 cy:bg-gray-100 cy:rounded cy:w-full cy:max-w-2xl cy:animate-pulse"></div>
        </div>

        {/* Content */}
        <div className="cy:p-6">
          {/* Checker Position Section */}
          <div className="cy:p-4 cy:border cy:border-gray-200 cy:rounded">
            <div className="cy:h-5 cy:bg-gray-200 cy:rounded cy:w-36 cy:mb-2 cy:animate-pulse"></div>
            <div className="cy:h-4 cy:bg-gray-100 cy:rounded cy:w-full cy:max-w-xl cy:mb-6 cy:animate-pulse"></div>

            <div className="cy:grid cy:grid-cols-2 cy:gap-8">
              {/* Left: Position Controls */}
              <div className="cy:space-y-4">
                <div className="cy:h-4 cy:bg-gray-200 cy:rounded cy:w-20 cy:mb-3 cy:animate-pulse"></div>
                <div className="cy:flex cy:gap-3">
                  <div className="cy:flex-1 cy:h-10 cy:bg-gray-200 cy:rounded cy:animate-pulse"></div>
                  <div className="cy:flex-1 cy:h-10 cy:bg-gray-200 cy:rounded cy:animate-pulse"></div>
                </div>
              </div>

              {/* Right: Preview */}
              <div className="cy:relative cy:flex cy:items-center cy:justify-center">
                <div className="cy:relative cy:w-full cy:h-[180px] cy:bg-gray-100 cy:rounded cy:border cy:border-gray-300">
                  {/* Browser chrome mockup */}
                  <div className="cy:absolute cy:top-2 cy:left-2 cy:flex cy:gap-1">
                    <div className="cy:w-2 cy:h-2 cy:rounded-full cy:bg-gray-300 cy:animate-pulse"></div>
                    <div className="cy:w-2 cy:h-2 cy:rounded-full cy:bg-gray-300 cy:animate-pulse"></div>
                    <div className="cy:w-2 cy:h-2 cy:rounded-full cy:bg-gray-300 cy:animate-pulse"></div>
                  </div>

                  {/* Content mockup */}
                  <div className="cy:absolute cy:top-8 cy:left-4 cy:right-4 cy:space-y-2">
                    <div className="cy:h-3 cy:bg-gray-200 cy:rounded cy:w-3/4 cy:animate-pulse"></div>
                    <div className="cy:h-2 cy:bg-gray-200 cy:rounded cy:w-full cy:animate-pulse"></div>
                    <div className="cy:h-2 cy:bg-gray-200 cy:rounded cy:w-5/6 cy:animate-pulse"></div>
                  </div>

                  {/* Scanner Icon Placeholder */}
                  <div className="cy:absolute cy:bottom-4 cy:right-2 cy:w-10 cy:h-10 cy:bg-gray-300 cy:rounded-full cy:animate-pulse"></div>
                </div>
              </div>
            </div>
          </div>

          {/* Save Button */}
          <div className="cy:pt-8">
            <div className="cy:h-10 cy:bg-gray-200 cy:rounded cy:w-32 cy:animate-pulse"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckerSkeletonLoader;

